import { connect } from 'react-redux';

import { ActionsMenu } from '../../components/ActionsMenu/ActionsMenu';
import { GridActionsMenu, GridActionsMenuProps } from '../../components/GridActionsMenu/GridActionsMenu';
import { gridActionsMenuSelector } from '../../selectors/gridActionsMenu/gridActionsMenu';
import {
    GridBannerItemActions,
    GridCampaignItemActions,
    GridFeedFilterItemActions,
    GridGroupItemActions,
    GridRetargetingItemActions
} from '../../typings/grid';
import { State } from '../../typings/state';

export type GridActionsMenuContainerActions =
    | GridCampaignItemActions
    | GridGroupItemActions
    | GridBannerItemActions
    | GridFeedFilterItemActions
    | GridRetargetingItemActions;

export interface GridActionsMenuContainerProps {
    index: number;
    actions: GridActionsMenuContainerActions;
    renderPromo?: (settingsLinkRef: ActionsMenu, isMenuActionsPopupOpened: boolean) => React.ReactNode;
}

const mapStateToPropsForGrid = (state: State, ownProps: GridActionsMenuContainerProps): GridActionsMenuProps => {
    return {
        ...gridActionsMenuSelector(state, ownProps),
        renderPromo: ownProps.renderPromo
    };
};

const mergeProps = (stateProps: GridActionsMenuProps): GridActionsMenuProps => {
    return stateProps;
};

export const GridActionsMenuContainer = connect<
    GridActionsMenuProps,
    {},
    GridActionsMenuContainerProps,
    GridActionsMenuProps
>(
    mapStateToPropsForGrid,
    undefined,
    mergeProps
)(GridActionsMenu);
